import { IOption } from '@shared/models/icommons.model';
import { IUserSettings } from '@shared/models/iuser-settings.model';
import { UserType, UserRole } from '@miq/user';
import { LocaleId } from './language.model';

export class IUserRequest {
  user: IUser;
  details?: ILocationPermission[];
  recordPermissions?: IRecordAccess[];
  exportLimits?: IExportLimits;
  settings?: IUserSettings;
  sendEmail?: boolean;

  constructor(
    user: IUser,
    permissionDetails?: ILocationPermission[],
    settings?: IUserSettings,
    recordPermissions?: IRecordAccess[],
    exportLimits?: IExportLimits
  ) {
    this.user = user;
    this.details = permissionDetails || [];
    this.recordPermissions = recordPermissions;
    this.exportLimits = exportLimits;
    this.settings = settings;
  }
}

/**
 * @deprecated Use User from '@miq/user' instead
 */
export class IUser {
  id?: number;
  username?: string;
  firstName?: string;
  lastName?: string;
  sendEmail?: boolean;
  emailAddress?: string;
  statusId?: number;
  statusVal?: string;
  userTypeId?: UserType;
  userTypeVal?: string;
  roleId?: number;
  roleVal?: string;
  managingOfficeName?: string;
  managingOfficeAddress?: string;
  expiryDate?: string;
  createBy?: string;
  updateBy?: string;
  createTs?: string;
  updateTs?: string;
  selected?: boolean;
  locationReqPending?: string;
  recordReqPending?: string;
  exists?: boolean;
  groups?: IOption[];
  userCountry?: string;
  userCountrySkey?: number;
  userLob?: string;
  userLobSkey?: number;
  userLocaleId?: LocaleId;
}

export interface IRecordAccess {
  id?: number;
  recordTypeId: number;
  recordTypeVal: string;
  recordID: string;
  recordDesc: string;
  statusId: number;
  createBy?: string;
  updateBy?: string;
}

export interface IExportLimits {
  availability: number;
  lease: number;
  sale: number;
  property: number;
  tim: number;
  company: number;
  contact: number;
  brand: number;
  portfoliosale: number;
  tenancy: number;
}

export interface IUserPermission {
  globalRegion?: IOption;
  country?: IOption;
  division: IOption;
  market: IOption;
  submarket?: IOption;
  district?: IOption[];
  subMarket?: IOption[];
  neighborhood?: IOption[];
  productType: IOption;
  status?: IOption;
}

export class ILocationPermission {
  id?: number;
  username?: string;
  globalRegionId: number;
  globalRegionVal: string;
  globalRegionName?: string;
  countryId: number;
  countryVal: string;
  countryName?: string;
  divisionId: number;
  divisionVal: string;
  divisionName?: string;
  marketId: number;
  marketVal: string;
  marketName?: string;
  productTypeId: number;
  productTypeVal: string;
  productTypeName?: string;
  subMarketId?: number;
  subMarketVal?: string;
  subMarketName?: string;
  districtId?: number;
  districtVal?: string;
  districtName?: string;
  neighborhoodId?: number;
  neighborhoodVal?: string;
  neighborhoodName?: string;
  accessRequestStatusId: number;
  accessRequestStatusVal: string;
  confidentialityTypeId: number;
  confidentialityTypeVal: string;
  propertyUsageTypeId: number;
  propertyUsageTypeVal: string;
  propertyUsageTypeName?: string;
  rowId?: number;
  createBy: string; // required to send.
  updateBy: string; // required to send.
  businessJustification: string;
}

export interface ICloneUser {
  email: string;
  type?: string;
}

export interface UserGroups {
  key: number;
  value: string;
  access: IOption[];
  desc: string;
}

export interface CatalogList {
  catalogId: number;
  countryId: number;
  catalogName: string;
  desc: string;
  countryName: string;
  systemValue?: boolean;
}
export interface CatalogAttributes {
  recordAttrIds: IRecordAttrs[];
  countryId: number;
  lobId: number;
}
export interface IRecordAttrs {
  columnId: number;
  mandatoryField: string;
  reorderPosition: number;
}

/**
 * @deprecated Use User from '@miq/user' instead
 */
export { UserType as UserType };

/**
 * @deprecated Use User from '@miq/user' instead
 */
export { UserRole as UserRole };

export enum UserConfidentiality {
  Level1 = 1,
  Level2 = 2,
  Level0 = 0,
}

export enum UserGroupEnum {
  LeaseAgreementReviewer = 16,
}
